import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  LayoutDashboard, Users, ShoppingBag, Package, ClipboardList,
  FileText, Truck, Radio, LogOut, ChevronLeft, ChevronRight, Settings
} from 'lucide-react';

const NAV = [
  { to: '/',          icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/customers', icon: Users,           label: 'Customers' },
  { to: '/orders',    icon: ShoppingBag,     label: 'Orders' },
  { to: '/products',  icon: Package,         label: 'Products' },
  { to: '/billing',   icon: FileText,        label: 'Billing Queue' },
  { to: '/reports',    icon: FileText,        label: 'Reports' },
  { to: '/no-contact', icon: FileText,        label: 'No Contact' },
  { to: '/jnt',      icon: FileText,        label: 'J&T Reports' },
  { to: '/bills',     icon: FileText,        label: 'Bills' },
  { to: '/shipments',  icon: Truck,           label: 'Shipments' },
  { to: '/live',      icon: Radio,           label: 'Live Session' },
  { to: '/postlive',  icon: ClipboardList,   label: 'Post-Live' },
  { to: '/stock',     icon: Package,         label: 'Stock' },
  { to: '/settings',  icon: Settings,        label: 'Settings' },
];

export default function Sidebar({ collapsed, setCollapsed }) {
  const { user, logout } = useAuth();
  return (
    <aside style={{
      width: collapsed ? 64 : 220,
      background: '#1e1b2e',
      borderRight: '1px solid #2d2a45',
      display: 'flex', flexDirection: 'column',
      transition: 'width .25s', overflow: 'hidden', flexShrink: 0,
      height: '100vh', position: 'sticky', top: 0
    }}>
      {/* Logo */}
      <div style={{ padding: '20px 16px', borderBottom: '1px solid #2d2a45', display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ width: 36, height: 36, borderRadius: 10, background: 'linear-gradient(135deg,#7c6af5,#c084fc)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0 }}>💎</div>
        {!collapsed && <div><div style={{ fontWeight: 700, fontSize: 14, color: '#e8e6f0' }}>123 Crystal</div><div style={{ fontSize: 11, color: '#6b6d85' }}>OMS</div></div>}
      </div>

      {/* Nav */}
      <nav style={{ padding: '12px 8px', flex: 1 }}>
        {NAV.map(({ to, icon: Icon, label }) => (
          <NavLink key={to} to={to} end={to === '/'} style={({ isActive }) => ({
            display: 'flex', alignItems: 'center', gap: 10,
            padding: '10px 12px', borderRadius: 9, marginBottom: 3,
            textDecoration: 'none',
            background: isActive ? '#7c6af525' : 'transparent',
            color: isActive ? '#a78bf8' : '#8b8da8',
            fontWeight: isActive ? 600 : 400, fontSize: 14,
            transition: 'all .15s', whiteSpace: 'nowrap'
          })}>
            <Icon size={18} style={{ flexShrink: 0 }} />
            {!collapsed && label}
          </NavLink>
        ))}
      </nav>

      {/* User + logout */}
      <div style={{ padding: '12px 8px', borderTop: '1px solid #2d2a45' }}>
        {!collapsed && (
          <div style={{ padding: '8px 12px', marginBottom: 6, color: '#6b6d85', fontSize: 12 }}>
            {user?.name} · {user?.role}
          </div>
        )}
        <button onClick={logout} style={{
          display: 'flex', alignItems: 'center', gap: 10,
          padding: '10px 12px', borderRadius: 9, width: '100%',
          background: 'transparent', border: 'none', cursor: 'pointer',
          color: '#ef4444', fontSize: 14, whiteSpace: 'nowrap'
        }}>
          <LogOut size={18} style={{ flexShrink: 0 }} />
          {!collapsed && 'Logout'}
        </button>
        <button onClick={() => setCollapsed(!collapsed)} style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: 10, borderRadius: 8, width: '100%',
          background: 'transparent', border: 'none', cursor: 'pointer', color: '#6b6d85'
        }}>
          {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
        </button>
      </div>
    </aside>
  );
}
